module.exports = __webpack_public_path__ + "img/td-icon1.a38cdbdb.png";